/* global axios */
import ApiClient from './ApiClient';

class CreditOverviewAPI extends ApiClient {
  constructor() {
    super('credit_overview', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }
}

export default new CreditOverviewAPI();
